var _a;
import { createSlice } from '@reduxjs/toolkit';
import { AppConsts } from '../../common/constants/app-consts';
var folderViewRequestDto = {
    page: AppConsts.DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.DEFAULT_PAGE_SIZE_FOLDER,
    sortField: 'Name',
    sortDirection: 'ASC'
};
var initialState = {
    folderViewRequest: folderViewRequestDto,
    isUpdateFolderGrid: false
};
var folderViewSlice = createSlice({
    name: 'folderView',
    initialState: initialState,
    reducers: {
        setFolderViewRequest: function (state, action) {
            state.folderViewRequest = action.payload;
        },
        setIsUpdateFolderGrid: function (state, action) {
            state.isUpdateFolderGrid = action.payload;
        }
    }
});
export var setFolderViewRequest = (_a = folderViewSlice.actions, _a.setFolderViewRequest), setIsUpdateFolderGrid = _a.setIsUpdateFolderGrid;
export default folderViewSlice.reducer;
